import { Button } from "@mui/material"
import { detachProductsFromDiscount } from "@/api/discountService"
import { useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { formatToDevanagariStyle } from "@/utilities/helper"

export default function DiscountProductTable({
  discount,
  discountId,
  finalPrice,
}) {
  const queryClient = useQueryClient()

  const handleRemove = (productId) => {
    detachProductsFromDiscount(discountId, [productId]).then(() => {
      toast.success("Product removed")

      queryClient.invalidateQueries({
        queryKey: ["discount", String(discountId)],
      })
    })
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr className="table-header-surface">
            <th style={th}>Product</th>
            <th style={th}>SKU</th>
            <th style={th}>Price</th>
            <th style={th}>Final Price</th>
            <th style={th}>Action</th>
          </tr>
        </thead>

        <tbody>
          {discount?.products?.map((product) => (
            <tr key={product.id}>
              <td style={td}>{product.name}</td>
              <td style={td}>{product.sku}</td>
              <td style={td}>
                Rs. {formatToDevanagariStyle(product.sell_price)}
              </td>
              <td style={td}>Rs. {finalPrice(product)}</td>
              <td style={td}>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={() => handleRemove(product.id)}
                >
                  Remove
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const th = {
  padding: "12px",
  textAlign: "left",
  border: "1px solid #ddd",
}

const td = {
  padding: "12px",
  border: "1px solid #ddd",
}
